/**
 * Created by henian.xu on 2018/7/19.
 *
 */

import CertExamPayStat from './CertExamPayStat';
import CertExamAuditStat from './CertExamAuditStat';
import VerticalGroupingStat from './VerticalGroupingStat';

export default {
    CertExamPayStat,
    CertExamAuditStat,
    VerticalGroupingStat,
};
